export enum PaymentMethodEnum {
  CREDIT_CARD = "credit_card",
  DEBIT_CARD = "debit_card",
  PIX = "pix",
  CASH = "cash",
  GRATUITO = "complimentary",
}
